"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var Icon_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Icon"));
var Image_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Image"));
var Loader_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Loader"));
var Table_1 = require("@sportnet/ui/lib/Table");
var utilities_1 = require("@sportnet/ui/lib/Themes/utilities");
var utilities_2 = require("@sportnet/ui/lib/utilities");
var date_fns_1 = require("date-fns");
var moment_1 = tslib_1.__importDefault(require("moment"));
var polished_1 = require("polished");
var React = tslib_1.__importStar(require("react"));
var utilities_3 = require("@sportnet/utilities");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
// import CompetitionsApi from '../../../api/CompetitionsApi';
var CoreApi_1 = tslib_1.__importDefault(require("../../../api/CoreApi"));
var setupApis_1 = require("../../../api/setupApis");
var config_1 = tslib_1.__importDefault(require("../../../utilities/config"));
var widgets_1 = tslib_1.__importDefault(require("../../../view/widgets"));
// import { getGoalsByTeams } from '../MatchesList/utilities';
setupApis_1.setupCoreApi();
setupApis_1.setupCompetitionsApi();
var TopPanel = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"])));
var PlayerName = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  font-size: ", ";\n  font-weight: bold;\n"], ["\n  font-size: ", ";\n  font-weight: bold;\n"])), polished_1.rem(25));
var PersonDetail = styled_components_1["default"].div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  ", " {\n    flex-direction: row;\n  }\n  justify-content: space-between;\n  padding-top: ", ";\n  & > div {\n    width: 100%;\n    text-align: center;\n    ", " {\n      width: 50%;\n      text-align: initial;\n    }\n  }\n  img {\n    width: ", ";\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  ", " {\n    flex-direction: row;\n  }\n  justify-content: space-between;\n  padding-top: ", ";\n  & > div {\n    width: 100%;\n    text-align: center;\n    ", " {\n      width: 50%;\n      text-align: initial;\n    }\n  }\n  img {\n    width: ", ";\n  }\n"])), utilities_1.mb('s'), polished_1.rem(20), utilities_1.mb('s'), polished_1.rem(200));
var Bio = styled_components_1["default"].div(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  font-size: ", ";\n"], ["\n  font-size: ", ";\n"])), polished_1.rem(14));
var Wrapper = styled_components_1["default"].div(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  font-family: 'Roboto', sans-serif;\n"], ["\n  font-family: 'Roboto', sans-serif;\n"])));
// const MATCHES_LIMIT = 10;
var C = function (props) {
    var id = props.id, appSpace = props.appSpace, handleClose = props.handleClose;
    var _a = React.useState(false), isFetching = _a[0], setIsFetching = _a[1];
    var _b = React.useState(null), organization = _b[0], setOrganization = _b[1];
    var _c = React.useState(null), user = _c[0], setUser = _c[1];
    // const [isFetchingMatches, setIsFetchingMatches] = React.useState(false);
    // const [matches, setMatches] = React.useState<any[]>([]);
    // const [matchesOffset, setMatchesOffset] = React.useState(0);
    // const [matchesTotal, setMatchesTotal] = React.useState(0);
    var _d = React.useState([]), sportExpertCompetenceTypes = _d[0], setSportExpertCompetenceTypesItems = _d[1];
    var fetchData = function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var ppo, userDetail, sportExpertCompetenceTypesItems, e_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsFetching(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, 6, 7]);
                    return [4 /*yield*/, CoreApi_1["default"].organizationPPOProfile(appSpace)];
                case 2:
                    ppo = _a.sent();
                    return [4 /*yield*/, CoreApi_1["default"].organizationPPOUser(appSpace, id, {
                            withRelatedAffiliations: true
                        })];
                case 3:
                    userDetail = _a.sent();
                    return [4 /*yield*/, CoreApi_1["default"].getCodelist('sport-expert-competence-type')];
                case 4:
                    sportExpertCompetenceTypesItems = _a.sent();
                    setOrganization(ppo);
                    setUser(userDetail);
                    setSportExpertCompetenceTypesItems(sportExpertCompetenceTypesItems.codelist || []);
                    return [3 /*break*/, 7];
                case 5:
                    e_1 = _a.sent();
                    alert(utilities_2.__('Nepodarilo sa získať podrobné údaje'));
                    return [3 /*break*/, 7];
                case 6:
                    setIsFetching(false);
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    // const getMatches = async (offset = 0) => {
    //   try {
    //     setIsFetchingMatches(true);
    //     const resMatches = await CompetitionsApi.getPlayerMatches(appSpace, id, {
    //       offset,
    //       limit: MATCHES_LIMIT,
    //     });
    //     setMatches(resMatches.matches);
    //     setMatchesTotal(resMatches.total);
    //     setMatchesOffset(resMatches.offset);
    //   } catch (e) {
    //     alert(__('Nepodarilo sa získať zoznam zápasov zvolenej osoby.'));
    //   } finally {
    //     setIsFetchingMatches(false);
    //   }
    // };
    var getPhotoUrl = function () {
        if (utilities_3.getProp(user || {}, ['bio', 0, 'photo', 'public_url'])) {
            return String(user.bio[0].photo.public_url);
        }
        else if (user && user.photo && user.photo.public) {
            return String(user.photo.public_url);
        }
        else if (organization) {
            return String(organization.logo_public_url);
        }
        return '';
    };
    React.useEffect(function () {
        fetchData();
    }, []);
    if (isFetching) {
        return (React.createElement("div", { style: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            } },
            React.createElement(Loader_1["default"], { size: "xl" })));
    }
    // const collectiveSportMatches = matches.filter(
    //   m => m.rules && ['futbal'].includes(m.rules.sport_sector),
    // );
    var translateCompetenceType = function (value) {
        var item = sportExpertCompetenceTypes.find(function (i) { return i.value === value; });
        if (item) {
            return item.label;
        }
        return '';
    };
    return (React.createElement(Wrapper, null,
        React.createElement(TopPanel, null,
            React.createElement(PlayerName, null, user && utilities_3.formatUserName(user)),
            React.createElement("div", { style: { cursor: 'pointer' }, onClick: function () { return handleClose(); } },
                React.createElement(Icon_1["default"], { name: "close", size: "xl" }))),
        React.createElement(PersonDetail, null,
            React.createElement("div", null,
                React.createElement(Image_1["default"], { src: getPhotoUrl() })),
            React.createElement("div", null,
                React.createElement(Table_1.Table, null,
                    React.createElement(Table_1.Tbody, null,
                        user && user.age && (React.createElement(Table_1.Tr, null,
                            React.createElement(Table_1.Td, null,
                                React.createElement("b", null, utilities_2.__('Vek'))),
                            React.createElement(Table_1.Td, null, user.age))),
                        user && user.birthplace && (React.createElement(Table_1.Tr, null,
                            React.createElement(Table_1.Td, null,
                                React.createElement("b", null, utilities_2.__('Miesto narodenia'))),
                            React.createElement(Table_1.Td, null, user.birthplace))),
                        user && user.deathdate && (React.createElement(Table_1.Tr, null,
                            React.createElement(Table_1.Td, null,
                                React.createElement("b", null, utilities_2.__('Dátum úmrtia'))),
                            React.createElement(Table_1.Td, null, moment_1["default"](user.deathdate).format('DD.MM.YYYY')))))))),
        React.createElement("br", null),
        React.createElement(Bio, null, user &&
            user.bio &&
            user.bio.map(function (i) { return React.createElement(widgets_1["default"], { items: i.widgets }); })),
        React.createElement("br", null),
        React.createElement(Table_1.Table, null,
            React.createElement(Table_1.Tbody, null,
                user && user.regnrs && user.regnrs.length > 0 && (React.createElement(Table_1.Tr, null,
                    React.createElement(Table_1.Td, null,
                        React.createElement("b", null, utilities_2.__('Registračné číslo'))),
                    React.createElement(Table_1.Td, null, user.regnrs.map(function (i) { return (React.createElement(React.Fragment, null,
                        i.regnr,
                        React.createElement("br", null))); })))),
                user && user.membership && user.membership.length > 0 && (React.createElement(Table_1.Tr, null,
                    React.createElement(Table_1.Td, null,
                        React.createElement("b", null, utilities_2.__('Členstvá'))),
                    React.createElement(Table_1.Td, null, user.membership.map(function (i, idx) { return (React.createElement(React.Fragment, null,
                        i.org_profile_name,
                        i.valid_from && (React.createElement(React.Fragment, null,
                            React.createElement("br", null),
                            utilities_2.__('od'),
                            ":",
                            ' ',
                            date_fns_1.format(new Date(i.valid_from), config_1["default"].DEFAULT_DATE_FORMAT))),
                        i.valid_to && (React.createElement(React.Fragment, null,
                            React.createElement("br", null),
                            utilities_2.__('do'),
                            ":",
                            ' ',
                            date_fns_1.format(new Date(i.valid_to), config_1["default"].DEFAULT_DATE_FORMAT))),
                        idx + 1 !== user.membership.length && (React.createElement(React.Fragment, null,
                            React.createElement("br", null),
                            React.createElement("br", null))))); })))),
                user &&
                    user.sport_expert_licenses &&
                    user.sport_expert_licenses.length > 0 && (React.createElement(Table_1.Tr, null,
                    React.createElement(Table_1.Td, null,
                        React.createElement("b", null, utilities_2.__('Kvalifikácie / licencie'))),
                    React.createElement(Table_1.Td, null, user.sport_expert_licenses.map(function (i, idx) { return (React.createElement(React.Fragment, null,
                        i.name,
                        i.documentnr && (React.createElement(React.Fragment, null,
                            React.createElement("br", null),
                            utilities_2.__('č. dokumentu'),
                            ": ",
                            i.documentnr)),
                        i.valid_from && (React.createElement(React.Fragment, null,
                            React.createElement("br", null),
                            utilities_2.__('od'),
                            ":",
                            ' ',
                            date_fns_1.format(new Date(i.valid_from), config_1["default"].DEFAULT_DATE_FORMAT))),
                        i.valid_to && (React.createElement(React.Fragment, null,
                            React.createElement("br", null),
                            utilities_2.__('do'),
                            ":",
                            ' ',
                            date_fns_1.format(new Date(i.valid_to), config_1["default"].DEFAULT_DATE_FORMAT))),
                        idx + 1 !== user.sport_expert_licenses.length && (React.createElement(React.Fragment, null,
                            React.createElement("br", null),
                            React.createElement("br", null))))); })))),
                user && user.sport_orgs && user.sport_orgs.length > 0 && (React.createElement(React.Fragment, null, user.sport_orgs.map(function (i, idx) { return (React.createElement(React.Fragment, null,
                    React.createElement(Table_1.Tr, null,
                        React.createElement(Table_1.Td, null,
                            React.createElement("b", null, utilities_2.__('Športovec'))),
                        React.createElement(Table_1.Td, null,
                            i.org_profile_name,
                            i.date_from && (React.createElement(React.Fragment, null,
                                React.createElement("br", null),
                                utilities_2.__('od'),
                                ":",
                                ' ',
                                date_fns_1.format(new Date(i.date_from), config_1["default"].DEFAULT_DATE_FORMAT))),
                            i.date_to && (React.createElement(React.Fragment, null,
                                React.createElement("br", null),
                                utilities_2.__('do'),
                                ":",
                                ' ',
                                date_fns_1.format(new Date(i.date_to), config_1["default"].DEFAULT_DATE_FORMAT))))))); }))),
                user && user.sport_expert_orgs && user.sport_expert_orgs.length > 0 && (React.createElement(React.Fragment, null, user.sport_expert_orgs.map(function (i, idx) { return (React.createElement(React.Fragment, null,
                    React.createElement(Table_1.Tr, null,
                        React.createElement(Table_1.Td, null,
                            React.createElement("b", null, translateCompetenceType(i.competence_type))),
                        React.createElement(Table_1.Td, null,
                            i.org_profile_name,
                            React.createElement("br", null),
                            utilities_2.__('od'),
                            ":",
                            ' ',
                            date_fns_1.format(new Date(i.date_from), config_1["default"].DEFAULT_DATE_FORMAT),
                            i.date_to && (React.createElement(React.Fragment, null,
                                React.createElement("br", null),
                                utilities_2.__('do'),
                                ":",
                                ' ',
                                date_fns_1.format(new Date(i.date_to), config_1["default"].DEFAULT_DATE_FORMAT))))))); })))))));
};
exports["default"] = C;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
